import numeral from 'numeral';
import 'numeral/locales/pt-br';

export default function initializeNumeral() {
  numeral.locale('pt-br');
}



// WEBPACK FOOTER //
// ./src/App/initializers/numeral.js